import type { Dispatch } from 'redux'

import {
  addUserErrorData,
  removeRowForAddUser,
} from '../../modules/addUserForm/actions'
import type {
  ErrorUsers,
  HandleType,
  UserType,
} from '../../modules/addUserForm/reducer'
import { getEmailValidationMessage } from './AddNewUserModal.utils'

export type AddUserFormRow<T> = {
  id: string
  data: T
}

export const clearAddUserRows = async (
  dispatch: Dispatch,
  users: AddUserFormRow<UserType>[]
) => {
  await dispatch(addUserErrorData([]))
  const remainingUserIds = users.map(user => user.id)
  remainingUserIds.forEach(userId => {
    dispatch(removeRowForAddUser(userId))
  })
}

export const buildAddUserErrorState = (
  newUsers: AddUserFormRow<UserType>[],
  errors: ErrorUsers[]
): ErrorUsers[] => {
  const newErrorArray: ErrorUsers[] = []

  newUsers.forEach(({ data }, index) => {
    const errObject = [...errors].find(errItem => errItem.index === index)
    newErrorArray.push({
      index: index,
      touched: errObject?.touched || false,
      error: getEmailValidationMessage(data.email),
    })
  })

  return newErrorArray
}

export const findAddUserRow = (
  users: AddUserFormRow<UserType>[],
  idChanging: string
) => users.find(({ id }) => id === idChanging)

export const applyAddUserRowChange = (
  updatedUser: AddUserFormRow<UserType>,
  event: HandleType
) => ({
  ...updatedUser.data,
  [event.name]: event.value,
})

export const touchAddUserEmailError = (
  users: AddUserFormRow<UserType>[],
  errors: ErrorUsers[],
  event: HandleType,
  idChanging: string
) => {
  const updatedUserIndex = users.findIndex(({ id }) => id === idChanging)
  const updatedErr = [...errors]
  const errobjectIndex = updatedErr?.findIndex(
    err => err.index === updatedUserIndex
  )
  if (updatedErr[errobjectIndex] && !updatedErr[errobjectIndex]?.touched) {
    updatedErr[errobjectIndex] = {
      touched: true,
      error: getEmailValidationMessage(event.value),
      index: updatedUserIndex,
    }
    return updatedErr
  }
  return undefined
}
